"use strict";

module.exports = /* @ngInject */ function(windowTitle) {
  var that = this;

  that.getTitle = function() {
    return windowTitle.get();
  };
};



// WEBPACK FOOTER //
// ./app/presentation/controllers/HeaderController.js